import React, { Component } from 'react'

export class Success extends Component {
	render() {
		return (
			<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1649_971)">
					<path d="M46.688 17.856L25.6 38.944L14.112 27.488L9.6 32L25.6 48L51.2 22.4L46.688 17.856ZM32
					0C14.336 0 0 14.336 0 32C0 49.664 14.336 64 32 64C49.664 64 64 49.664 64 32C64 14.336 49.664
					0 32 0ZM32 57.6C17.856 57.6 6.4 46.144 6.4 32C6.4 17.856 17.856 6.4 32 6.4C46.144 6.4 57.6
					17.856 57.6 32C57.6 46.144 46.144 57.6 32 57.6Z" fill="#28A745" />
				</g>
				<defs>
					<clipPath id="clip0_1649_971">
						<rect width="64" height="64" fill="white" />
					</clipPath>
				</defs>
			</svg>

		)
	}
}

export default Success
